module.exports = __webpack_public_path__ + "img/wenhua (6).409df494.png";